<!-- @format -->

<template>
	<el-switch
		v-model="value"
		:style="{
			'--el-switch-on-color': activeColor,
			'--el-switch-off-color': inactiveColor,
		}"
	/>
</template>

<script setup lang="ts">
	interface Props {
		modelValue: boolean;
		activeColor: string;
		inactiveColor: string;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: false,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
